var map = {
	"./cloud1.png": "c91c",
	"./cloud2.png": "487a",
	"./cloud3.png": "9a8a",
	"./cloud4.png": "e8c7",
	"./cloud5.png": "3207",
	"./cloud6.png": "45ed",
	"./cloud7.png": "b367"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c56d";